// extracted by mini-css-extract-plugin
module.exports = {"disclaimer":"DocumentUploadedNote_disclaimer__2cTfm","note":"DocumentUploadedNote_note__2pUO8","infoIcon":"DocumentUploadedNote_infoIcon__1YL53"};